import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { ActionChange } from "../../ActionInfo/ActionInfo";

export const meetsCostRequirementsSingle = (
  cost: ActionChange,
  costIncrement: number,
  costScale: number,
  newBricks: Map<string, BrickInventoryEntry>,
) => {
  // Validate if costs for action can be met
  const trueCost = cost.baseChangeValue + costIncrement * costScale;
  const currBrick = newBricks.get(cost.brickId);

  // If brick doesn't exist or amount is NaN, cost requirements are not met
  if (!currBrick || Number.isNaN(currBrick.amount)) {
    return false;
  }

  return currBrick.amount >= trueCost;
};
